<template>
  <v-tabs v-model="activeTableTab">
    <h2
      tabindex="-1"
      id="tableHeading"
      class="text-subtitle-1 black--text mt-2 ml-3 pa-1 mb-1"
    >
      Tabellvisning:
    </h2>
    <v-tab class="ml-2" ripple @keyup.space="activeTableTab = 0">
      <v-icon class="pr-2">mdi-table</v-icon>NVE tidsserier
    </v-tab>
    <v-tab ripple @keyup.space="activeTableTab = 1">
      <v-icon class="pr-2">mdi-table</v-icon>Andre tidsserier
    </v-tab>
    <v-spacer></v-spacer>
    <the-column-selector class="pt-2" />

    <v-tab-item :eager="true">
      <data-table
        :is-split-view="tableVisible && mapVisible && horizontalSplitView"
        @selection-changed="updateSelectedTimeSeries"
        @count-changed="updateNVETimeSeriesCount"
        :all-headers="vheaders"
        :headers="selectedColumns"
        :data-url="mainLayerUrl"
        :select-time-series="selectedTimeSeries"
        :query-expression="queryExpression"
        sort-by="stasjonNavn"
        class="tidsserie-table"
      ></data-table>
    </v-tab-item>
    <v-tab-item :eager="true">
      <data-table
        v-if="showStationsFromOtherActors"
        :is-split-view="tableVisible && mapVisible && horizontalSplitView"
        @selection-changed="updateSelectedTimeSeriesOtherActors"
        @count-changed="updateOtherTimeSeriesCount"
        :all-headers="otherTimeseriesHeaders"
        :headers="selectedColumnsOtherActors"
        :select-time-series="selectedTimeSeriesOtherActors"
        :data-url="otherActorsLayerUrl"
        sort-by="STASJONSNAVN"
        :query-expression="queryExpressionStationsFromOtherActors"
        class="tidsserie-table"
      ></data-table>
      <v-container
        fill-height
        :style="{
          height:
            tableVisible && mapVisible && horizontalSplitView
              ? '300px'
              : '70vh',
        }"
        class="fill-height fluid "
        fluid
        v-else
      >
        <v-col
          fill-height
          justify="center"
          align="center"
          class="justify-start align-center"
        >
          <p>
            Du har ikke aktivert visning av tidsserier fra andre aktører. Ønsker
            du å aktivere dette nå?
          </p>
          <v-btn depressed @click="setShowStationsFromOtherActors(true)"
            >Vis tidsserier fra andre aktører</v-btn
          >
        </v-col>
      </v-container>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapActions, mapState } from "vuex";
import DataTable from "./DataTable.vue";
import TheColumnSelector from "../Layout/TheColumnSelector.vue";

export default {
  name: "DataTablePanel",
  props: {
    tableVisible: Boolean,
    mapVisible: Boolean,
    horizontalSplitView: Boolean,
  },
  data: () => {
    return {
      nveTimeSeriesCount: 0,
      otherTimeSeriesCount: 0,
    };
  },
  components: {
    DataTable,
    TheColumnSelector,
  },
  watch: {
    showStationsFromOtherActors: function(newVal) {
      if (newVal === true) {
        this.setTimeSeriesCount(
          this.nveTimeSeriesCount + this.otherTimeSeriesCount
        );
      } else {
        this.otherTimeSeriesCount = 0;
        this.setTimeSeriesCount(this.nveTimeSeriesCount);
      }
    },
  },
  computed: {
    ...mapState([
      "queryExpression",
      "vheaders",
      "otherTimeseriesHeaders",
      "queryExpressionStationsFromOtherActors",
      "currentMapExtent",
      "selectedColumns",
      "selectedColumnsOtherActors",
      "showStationsFromOtherActors",
      "selectedTimeSeries",
      "selectedTimeSeriesOtherActors",
    ]),
    showStationsFromOtherActors: {
      set(showStationsFromOtherActors) {
        this.setShowStationsFromOtherActors(showStationsFromOtherActors);
      },
      get() {
        return this.$store.state.showStationsFromOtherActors;
      },
    },
    activeTableTab: {
      get() {
        return this.$store.state.activeTableTab;
      },
      set(newValue) {
        return this.$store.dispatch("setActiveTableTab", newValue);
      },
    },
    mainLayerUrl: function() {
      return (
        process.env.VUE_APP_BASE_URL +
        "/" +
        process.env.VUE_APP_BASE_URL_LAYER_INDEX
      );
    },
    otherActorsLayerUrl: function() {
      return (
        process.env.VUE_APP_SECOND_LAYER_URL +
        process.env.VUE_APP_SECOND_URL_LAYER_INDEX
      );
    },
  },
  methods: {
    ...mapActions([
      "setSplitSize",
      "setShowStationsFromOtherActors",
      "setSelectedTimeSeries",
      "setSelectedTimeSeriesOtherActors",
      "setTimeSeriesCount",
    ]),
    updateSelectedTimeSeries(selectedTimeSeries) {
      this.setSelectedTimeSeries(selectedTimeSeries);
    },
    updateSelectedTimeSeriesOtherActors(selectedTimeSeries) {
      this.setSelectedTimeSeriesOtherActors(selectedTimeSeries);
    },
    updateNVETimeSeriesCount(newCount) {
      this.nveTimeSeriesCount = newCount;
      if (this.showStationsFromOtherActors) {
        this.setTimeSeriesCount(
          this.nveTimeSeriesCount + this.otherTimeSeriesCount
        );
      } else {
        this.setTimeSeriesCount(this.nveTimeSeriesCount);
      }
    },
    updateOtherTimeSeriesCount(newCount) {
      this.otherTimeSeriesCount = newCount;
      if (this.showStationsFromOtherActors) {
        this.setTimeSeriesCount(
          this.nveTimeSeriesCount + this.otherTimeSeriesCount
        );
      } else {
        this.setTimeSeriesCount(this.nveTimeSeriesCount);
      }
    },
  },
};
</script>

<style></style>
